import React from 'react'

import Calendar from '../common/Calendar/Calendar.tsx'
import Card from '../common/Card/Card.tsx'

const StatisticsDatesChooser = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  lastDay
}: {
  fromDate: string
  toDate: string
  setFromDate: React.Dispatch<React.SetStateAction<string>>
  setToDate: React.Dispatch<React.SetStateAction<string>>
  lastDay: string
}) => {
  return (
    <Card className="mb-6">
      <Card.Body>
        <div>
          <p className="text-[20px]">Zakres dat</p>
          <div className={'flex-1 flex flex-col md:flex-row gap-2 mt-2'}>
            <Calendar
              placeholder={'Od:'}
              defaultDate={fromDate}
              setDate={setFromDate}
              maxDate={lastDay}
            />
            <Calendar
              placeholder={'Do:'}
              defaultDate={toDate}
              setDate={setToDate}
              maxDate={lastDay}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default StatisticsDatesChooser
